import { motion } from "framer-motion";
import ContactForm from "@/components/ContactForm";
import Seo from "@/components/Seo";
import { organizationSchema, breadcrumbSchema } from "@/lib/schemas";

const EASE = [0.76, 0, 0.24, 1];

export default function ContactPage() {
  return (
    <div>
      <Seo
        title="Contact — Start a conversation"
        description="Share your context. We reply within one business day with a scoped proposal — scope, timeline and price. No cold emails, no spam list."
        path="/contact"
        jsonLd={[
          organizationSchema(),
          breadcrumbSchema([
            { name: "Home", path: "/" },
            { name: "Contact", path: "/contact" },
          ]),
        ]}
      />
      <section className="pt-40 pb-16 bg-[var(--bg)] border-b border-[var(--line-strong)]">
        <div className="max-w-[1440px] mx-auto px-6 md:px-10 grid md:grid-cols-12 gap-8">
          <div className="md:col-span-4">
            <p className="overline mb-6">Contact · Start a conversation</p>
          </div>
          <div className="md:col-span-8">
            <motion.h1
              initial={{ opacity: 0, y: 40 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 1, ease: EASE }}
              className="font-display text-5xl md:text-7xl lg:text-8xl tracking-[-0.03em] leading-[0.92] text-[var(--ink)]"
            >
              Fill the form.{" "}
              <span className="font-serif-accent italic text-[var(--accent)]">
                We&apos;ll reach out.
              </span>
            </motion.h1>
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 1, delay: 0.2, ease: EASE }}
              className="mt-8 text-[var(--ink-80)] text-lg leading-relaxed max-w-2xl"
            >
              A 30-minute discovery call to understand your stage, your team
              and the outcome you need. If we&apos;re the right fit, we&apos;ll come back
              with a scoped proposal within a business day.
            </motion.p>
          </div>
        </div>
      </section>

      {/* Direct details */}
      <section className="py-12 bg-[var(--bg)] border-b border-[var(--line-strong)]">
        <div className="max-w-[1440px] mx-auto px-6 md:px-10 grid sm:grid-cols-3 gap-8">
          {[
            { k: "Phone", v: "+91 77380 13098", href: "tel:+917738013098", testId: "contact-phone-link" },
            { k: "Email", v: "sales@orphionglobalhr.com", href: "mailto:sales@orphionglobalhr.com", testId: "contact-email-link" },
            { k: "Office", v: "Bengaluru, India", href: null, testId: "contact-office" },
          ].map((c) => (
            <div key={c.k} className="border-t border-[var(--line-strong)] pt-5">
              <p className="overline mb-2">{c.k}</p>
              {c.href ? (
                <a
                  href={c.href}
                  data-testid={c.testId}
                  className="link-slide text-[var(--ink)] text-lg"
                >
                  {c.v}
                </a>
              ) : (
                <p className="text-[var(--ink)] text-lg" data-testid={c.testId}>{c.v}</p>
              )}
            </div>
          ))}
        </div>
      </section>

      <ContactForm />
    </div>
  );
}
